import styled from 'styled-components';
import { Wrapper } from '../../../../NetWorthSidebarStyles';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { MIN_WIDTH, MAX_WIDTH } from '../../DraggableWrapper.meta';

export const Content = styled(Box)({
  overflowY: 'auto',
});

export const ExtendedWrapper = styled(Wrapper)({
  minWidth: `${MIN_WIDTH}px`,
  maxWidth: `${MAX_WIDTH}px`,
});

export const DraggableHandler = styled(Box)<{ isDragging: boolean }>(({ isDragging, theme }) => ({
  position: 'absolute',
  width: '2px',
  top: 0,
  bottom: 0,
  right: 0,
  margin: 'auto',
  background: isDragging ? theme.colors.primary['500'] : theme.colors.neutral['200'],
  '&:hover': {
    width: '4px',
    cursor: 'ew-resize',
  },
}));
